var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"!w-[145px] rounded-0",attrs:{"searchable":false,"reduce":val => val.key,"label":"name","options":_vm.locations},on:{"option:selected":val => _vm.$emit('selected', val)},model:{value:(_vm.location),callback:function ($$v) {_vm.location=$$v},expression:"location"}})
}
var staticRenderFns = []

export { render, staticRenderFns }